const queryKeys = {
  activeFactPush: 'push',
  activeTilePush: 'push',
  activeHotelSectionPush: 'hotelPush',
  activeHotelSection: 'section',
};

export default queryKeys;
